<script>
  import {url} from '@sveltech/routify';

  import Caja from "../../UI/Caja.svelte";
  import Boton from "../../UI/Boton.svelte";
  import Subtitulo from "../../UI/Subtitulo.svelte";

  import {format} from 'date-fns';
  import {es} from 'date-fns/locale';

  import store from '../../../Stores/Trabajadores/ver-trabajador-store';

  import {nombreCompleto} from '../../../Modelos/Trabajador';
  import Loading from "../../UI/Loading.svelte";

  let trabajador, nombre;
  $: trabajador = $store.trabajador.trabajador;
  $: nombre = nombreCompleto(trabajador);
</script>

{#if $store.trabajador.cargando}
    <Caja cabecera={false} pie={false}>
        <Loading/>
    </Caja>
{:else if $store.trabajador.error}
    <Caja cabecera={false} pie={false}>
        Error cargando trabajador
    </Caja>
{:else}
    <Caja>
        <div slot="titulo">
            <Subtitulo icono="face">
                {nombre}
                {#if trabajador?.eliminacion}<br>(Inactivo){/if}
            </Subtitulo>
        </div>

        <dl>
            <dt>Código</dt>
            <dd>{trabajador.codigo}</dd>
            <dt>Teléfono</dt>
            <dd>{trabajador.telefono}</dd>
            <dt>NIF</dt>
            <dd>{trabajador.nif}</dd>
            {#if trabajador.grupo}
                <dt>Grupo</dt>
                <dd>{trabajador.grupo.nombre}</dd>
            {/if}
            {#if trabajador.antiguedad}
                <dt>Antigüedad</dt>
                <dd>{format(new Date(trabajador.antiguedad), 'dd/MM/yyyy', {locale: es})}</dd>
            {/if}
        </dl>

        <div slot="botones">
            <Boton href={$url(`/trabajadores/${trabajador.id}/editar`)} icono="edit">
                Editar trabajador
            </Boton>
        </div>
    </Caja>
{/if}

<style>
    dt, dd {
        display: inline;
        margin: 0;
        padding: 0;
    }

    dt {
        font-weight: 600;
    }

    dt:after {
        content: ':';
        margin-right: .5em;
    }

    dd:after {
        content: '\A';
        white-space: pre;
    }
</style>